import { useQuery } from "@tanstack/react-query";
import { getSsoClients } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const SSO_CLIENTS_QUERY_KEY = "SSO_CLIENTS";

export const ssoClientsKeys = {
  all: [SSO_CLIENTS_QUERY_KEY],
};

export const useSsoClientsQuery = () =>
  useQuery({
    queryKey: ssoClientsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() => getSsoClients()),
    staleTime: MS_TIME.minute,
  });
